export default {
  common: {
    clearAll: 'Wyczyść wszystko',
    required: 'Wymagany',
    restart: 'Uruchom ponownie stronę'
  },
  createUser: {
    acceptTermsAndConditions: 'Zaakceptuj zasady i warunki',
    alreadyHaveAccount: 'Masz już konto? %{pre}Pobierz%{post}',
    checkEmail: 'W międzyczasie pobierz na swój komputer program Metrica Play',
    clubCompany: 'Organizacja/Klub',
    createdSuccessfully:
      'Rejestracja przebiegła pomyślnie! Sprawdź swój adres e-mail podany podczas rejestracji w celu kliknięcia w link weryfikacyjny (sprawdź folder spam).',
    email: 'E-mail',
    invalidEmail: 'Nieprawidłowy adres e-mail',
    job: 'Stanowisko/Rola',
    lastName: 'Nazwisko',
    name: 'Imię',
    noCustomOption: 'Opcja niedostępna',
    noMatches: 'Brak dopasowania, wpisz własną opcję',
    password: 'Hasło',
    passwordsDontMatch: 'Hasła nie pasują do siebie',
    passwordInvalid: 'Hasło nie spełnia wymagań',
    passwordRequirements: {
      minLength: 'Co najmniej %{count} znaków',
      uppercase: 'Jedna wielka litera',
      lowercase: 'Jedna mała litera',
      number: 'Jedna cyfra (0-9)',
      maxLength: 'Maksymalna liczba znaków: %{count}'
    },
    phone: 'Telefon',
    phoneCode: 'Kraj',
    proceed: 'Kontynuuj',
    repeatPassword: 'Powtórz hasło',
    searchPhoneCode: 'Szukaj...',
    seeTermsAndConditions: 'Zobacz warunki i zasady',
    signAgreement:
      'Rejestracja konta w Metrica Sports oznacza, że zgadzasz się na %{pre1}Politykę Prywatności%{post1} oraz %{pre2}Warunki Świadczenia Usług%{post2}',
    signUpHere: 'Utwórz konto, aby rozpocząć.',
    sport: 'Sport',
    submitting: 'Rozpoczynanie...',
    title: 'Zacznij korzystać z %{product}',
    userKeyField: 'Masz kod promocyjny lub klucz użytkownika? Wypełnij to pole'
  },
  error: {
    downloadPlay: 'Jeśli masz już konto, pobierz najnowszą wersję aplikacji Play i zaloguj się.',
    emailTaken: 'Ten adres e-mail został już wykorzystany',
    fieldTooLong: 'Niektóre pola są za długie. Skróć je i spróbuj ponownie',
    oops: 'Ups!',
    restart: 'Wygląda na to, że próbujesz wejść w coś, nad czym wciąż pracujemy...',
    tryAgain:
      'Prosimy spróbować ponownie, jeśli błąd nadal występuje, skontaktuj się z zespołem pomocy technicznej Metrica Sports.',
    userKey:
      'Klucz jest nieprawidłowy. Sprawdź swój klucz i spróbuj ponownie lub usuń pole, aby zakończyć rejestrację.'
  },
  invitation: {
    acceptButton: 'Akceptuję Zmianę Mojej Konta',
    accepting: 'Akceptując...',
    cancelButton: 'Odrzucić',
    description1:
      'Gdy zostaniesz dodany do nowego konta Metrica Sports, własność Twojego obecnego konta Metrica Sports (oraz informacje w nim zawarte) zostanie przeniesiona i przypisana do nowego właściciela konta Metrica Sports. Wszystkie informacje i dane aktualnie zawarte na Twoim koncie Metrica Sports, jak również wszelkie informacje lub dane zapisane po zaakceptowaniu zmiany konta, będą widoczne i dostępne dla nowego właściciela konta Metrica Sports oraz dla każdego administratora tego konta, do użytku i udostępniania innym według uznania właściciela konta.',
    description2: 'Klikając "Akceptuję zmianę mojego konta", zgadzasz się i upoważniasz do:',
    list1:
      'Informacje dotyczące Twojego obecnego konta zostaną przeniesione na nowe konto Metrica Sports.',
    list2:
      'Cała informacja o koncie przeniesiona na Twoje nowe konto Metrica Sports z Twojego obecnego konta może być zarządzana przez nowego właściciela konta i/lub administratora(ów).',
    list3:
      'W nowym koncie Metrica Sports Twoja rola będzie „Członkiem”. Nie będziesz już miał uprawnień właściciela ani administratora z Twojego obecnego konta.',
    list4:
      'Odziedziczysz istniejące ustawienia Twojego nowego konta Metrica Sports, które mogą być bardziej lub mniej restrykcyjne w zależności od Twojej roli na koncie, a Twoje ustawienia mogą być zarządzane przez nowego właściciela lub administratora(ów) konta Metrica Sports.',
    list5:
      'Twoje obecne ustawienia mogą zostać zmienione, jeśli będą sprzeczne z ustawieniami konta nowego, do którego dołączasz.',
    list6:
      'Możliwe, że Twoje nowe konto nie zapewni dostępu do wszystkich funkcji, które posiadasz na swoim obecnym koncie.',
    list7:
      'Nie jest możliwe cofnięcie transferu Twojego konta po jego zainicjowaniu przez Ciebie, a cała Twoja informacja o koncie pozostanie na jednym koncie.',
    list8:
      'Klikając „Akceptuję Zmianę Mojego Konta”, zostaniesz zarządzanym członkiem konta %{pre1}%{email}%{post1} i zgadzasz się na %{pre2}Warunki Świadczenia Usług%{post2} oraz %{pre3}Oświadczenie o Prywatności%{post3} Metrica Sports.',
    subtitle:
      'Przyjmując to nowe zaproszenie do konta Metrica Sports, zostaniesz dodany do innego konta Metrica Sports.',
    title: 'Zaproszenie'
  },
  jobs: {
    academyDirector: 'Dyrektor Akademii',
    assistantCoach: 'Asystent Trenera',
    dataAnalyst: 'Analityk - statystyk',
    doctor: 'Doktor',
    formerPlayer: 'Były piłkarz',
    goalkeeperCoach: 'Trener bramkarzy',
    headCoach: 'Pierwszy Trener',
    journalist: 'Dziennikarz / Redaktor sportowy',
    other: 'Inne',
    performance: 'Trener przygotowania motorycznego',
    player: 'Zawodnik',
    scout: 'Scout',
    sportsDirector: 'Dyrektor Sportowy',
    student: 'Student / Uczeń',
    videoAnalyst: 'Analityk wideo'
  },
  sports: {
    americanFootball: 'Futbol amerykański',
    baseball: 'Baseball',
    basketball: 'Koszykówka',
    fieldHockey: 'Hokej na trawie',
    football: 'Piłka nożna',
    futsal: 'Futsal',
    gaelicFootball: 'Futbol gaelicki',
    handball: 'Piłka ręczna',
    iceHockey: 'Hokej na lodzie',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Inne',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tenis',
    volleyball: 'Siatkówka'
  }
}
